import React, { Component, PropTypes } from 'react';
import './Koffing.scss';

class Koffing extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="koffing">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Koffing;



/** WEBPACK FOOTER **
 ** ./source/109-koffing/Koffing.js
 **/